module.exports = __webpack_public_path__ + "static/media/Helmet.c54f4337.jpg";